import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const StyledTitle = styled(Typography, {
  shouldForwardProp: prop => prop !== 'titleVariant',
})(({ titleVariant }) => ({
  // 다크 헤더(#333 등) 위에 올라가는 흰 텍스트가 baseline.
  color: '#fff',
  ...(titleVariant === 'default' && {
    fontSize: '20px',
    fontWeight: 600,
  }),
  ...(titleVariant === 'large' && {
    fontSize: '20px',
    fontWeight: 600,
  }),
  // 라이트 헤더(흰 배경) 위에서 사용하는 진한 텍스트.
  ...(titleVariant === 'light' && {
    color: '#262626',
    fontSize: '18px',
    fontWeight: 700,
  }),
}));

const CommonModalTitle = ({ variant = 'default', children, ...rest }) => (
  <StyledTitle titleVariant={variant} {...rest}>
    {children}
  </StyledTitle>
);

export default CommonModalTitle;
